<h1 mat-dialog-title>{{ title }}</h1>

<mat-dialog-content>
  <app-card-spinner [visible]="dialogIsLoading" type="zero"></app-card-spinner>

  <div class="form-wrapper mt-1">
    <h4>Combinazione dei parametri della struttura:</h4>    
    <form [formGroup]="form">
      <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options">
      </formly-form>
    </form>
  </div>
  <div class="form-wrapper mt-1">
    <h4>Documenti da attivare:</h4>    
    <form [formGroup]="docForm">
      <formly-form [form]="docForm" [fields]="docFields" [model]="docModel" [options]="docOptions">
      </formly-form>
    </form>
  </div>
</mat-dialog-content>

<div mat-dialog-actions class="mt-5">
  <div class="row w-100">
    <div class="col-6 text-left">
      <a mat-button (click)="onClose()" mat-raised-button mat-default color="warn">
        {{ 'common.cta.close' | translate }}
      </a>
    </div> <!-- /.col -->
    <div class="col-6 text-right">
      <a mat-button (click)="onSave()" mat-raised-button mat-default color="warn">
        {{ 'common.cta.save' | translate }}
      </a>
    </div>
  </div> <!-- /.row -->
</div>
